import "fetch-everywhere";
import { apiUrl } from "../Helper/helper";
import {
  UK_CURRENCY,
  USA_CURRENCY,
  EU_CURRENCY,
} from "../Component/SearchResult/New/constants";
export default {
  async sendApiRequest(url, method, setauth, body) {
    const requestOptions = {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    };
    if (method === "DELETE") {
      delete requestOptions.body;
    }
    if (method === "GET") {
      delete requestOptions.body;
    }

    if (setauth === true) {
      let token = window.user ? window.user.token : "no-token";
      requestOptions.headers["Authorization"] = "Bearer " + token;
    }

    try {
      const response = await fetch(apiUrl + url, requestOptions);
      let body = await response.text();
      if (response.status !== 200) {
        throw body;
      }
      const data = JSON.parse(body);
      return data;
    } catch (e) {
      throw e;
    }
  },
};

export function getCurrency() {
  const hostname = window.location.hostname;
  if (hostname.startsWith("eu.")) {
    return EU_CURRENCY;
  } else if (hostname.includes(".com")) {
    return USA_CURRENCY;
  } else {
    return UK_CURRENCY;
  }
}

export function getCurrencySymbol() {
  if (getCurrency() === USA_CURRENCY) {
    return "$";
  } else if (getCurrency() === EU_CURRENCY) {
    return "€";
  } else {
    return "£";
  }
}

export function getCurrencySymbolViaCode(code) {
  switch (code) {
    case USA_CURRENCY:
      return "$";
    case EU_CURRENCY:
      return "€";
    default:
      return "£";
  }
}
